import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@stores';
import { Title, SendBtnWrapper } from './styles';
import BookmarkOverlay from '@components/BookmarkOverlay';
import Button from '@components/Button';
import BookmarksList from '@components/BookmarksList';
import SendMailOverlay from '@components/SendMailOverlay';
import Wrapper from '@components/Wrapper';
import { PAGE_PADDING_TOP } from '@constants';

const BookmarksPage = () => {
  const {
    contentStore: { eventData },
    bookmarksStore: { bookmarksData },
  } = useStores();

  const [selectedBookmark, setSelectedBookmark] = useState();
  const [sendMailOverlayOpen, setSendMailOverlayOpen] = useState(
    bookmarksData?.length === 0 || eventData?.disableBookmarkEmails
      ? false
      : true
  );

  const noBookmarks = bookmarksData?.length === 0;

  return (
    <Wrapper padding={`${PAGE_PADDING_TOP}px 20px 20px`}>
      <Title>Your Basket</Title>
      <BookmarksList
        bookmarksData={bookmarksData}
        setSelectedBookmark={setSelectedBookmark}
        noBookmarks={noBookmarks}
      />
      {!noBookmarks && !eventData?.disableBookmarkEmails && (
        <SendBtnWrapper>
          <Button
            title="Checkout"
            fontSize={14}
            styles="width: 100%; max-width: 450px; padding: 12px 30px;"
            onClick={() => setSendMailOverlayOpen(true)}
          />
        </SendBtnWrapper>
      )}
      {selectedBookmark && (
        <BookmarkOverlay
          selectedBookmark={selectedBookmark}
          setSelectedBookmark={setSelectedBookmark}
        />
      )}
      {sendMailOverlayOpen && !eventData?.disableBookmarkEmails && (
        <SendMailOverlay setSendMailOverlayOpen={setSendMailOverlayOpen} />
      )}
    </Wrapper>
  );
};

export default observer(BookmarksPage);
